import { useState, useEffect } from "react";
import dayjs from "dayjs";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const Datepicker = ({
  id = "",
  name = "",
  label = "",
  wrapperClassName = "",
  change = () => {},
  blur = () => {},
  inputClass = "",
  min = undefined,
  max = undefined,
  value = "",
  error = false,
  touched = false,
  disabled,
}) => {
  const [selectedDate, setSelectedDate] = useState(value);

  const onChange = (e) => {
    setSelectedDate(e);
    if (e) change(dayjs(e).format("MM/DD/YYYY"));
    else change("");
  };

  const handleChangeRaw = (e) => {
    const allowedChars = /^[0-9/]*$/;
    if (!allowedChars.test(e.target.value)) {
      e.preventDefault();
    }

    const val = e?.target?.value || e;

    const parsedDate = dayjs(val, "MM/DD/YYYY", true);

    if (parsedDate.isValid() && val && val.length === 10) {
      setSelectedDate(parsedDate.toDate());
    }
  };

  const handleBlur = () => {
    const minDate = dayjs(min, "MM/DD/YYYY");
    const maxDate = dayjs(max, "MM/DD/YYYY");
    const parsed = dayjs(selectedDate, "MM/DD/YYYY", true);

    if (parsed.toString() !== "Invalid Date") {
      if (min && parsed.isBefore(minDate)) {
        setSelectedDate(minDate);
        change(minDate.format("MM/DD/YYYY"));
        blur(minDate.format("MM/DD/YYYY"));
      } else if (max && parsed.isAfter(maxDate)) {
        setSelectedDate(maxDate);
        change(maxDate.format("MM/DD/YYYY"));
        blur(maxDate.format("MM/DD/YYYY"));
      } else {
        change(dayjs(parsed).format("MM/DD/YYYY"));
        blur(dayjs(parsed).format("MM/DD/YYYY"));
      }
    } else {
      blur("");
    }
  };

  useEffect(() => {
    if (!value) {
      setSelectedDate("");
    }
  }, [value]);

  return (
    <div className={`form-group ${wrapperClassName}`}>
      <label htmlFor={id} className="form-label input-label d-block mb-1">
        {label}
      </label>
      <DatePicker
        id={id}
        name={name}
        className={`form-control ${inputClass} ${
          error && touched && "is-invalid"
        }`}
        placeholderText="MM/DD/YYYY"
        dateFormat="MM/dd/yyyy"
        disabled={disabled}
        maxDate={max}
        minDate={min}
        selected={selectedDate}
        onChange={onChange}
        onChangeRaw={handleChangeRaw}
        onBlur={handleBlur}
      />
      {error && touched && <span className="error">{error}</span>}
    </div>
  );
};

export default Datepicker;
